import api from '../services/api'
import { RESET } from '../redux/game'

// Actions
const FETCHING_EXCO_START = 'ascension/exco/fetching'
const FETCHING_EXCO_SUCCESS = 'ascension/exco/success'
const FETCHING_EXCO_ERROR = 'ascension/exco/error'

const SUBMITTING_EXCO_START = 'ascension/exco/submitting'
const SUBMITTING_EXCO_SUCCESS = 'ascension/exco/submitted'
const SUBMITTING_EXCO_ERROR = 'ascension/exco/submitting_error'

// Reducer
const initialState = {
  isLoading: false,
  isLoaded: false,
  error: null,
  isSubmitting: false,
  id: 1,
  name: null,
  description: null,
  options: [],
  decision: false
}

const reducer = (state = initialState, action = {}) => {
  switch (action.type) {
    case FETCHING_EXCO_START: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        id: 1,
        name: null,
        description: null,
        options: [],
        decision: false,
        error: null
      }
    }
    case FETCHING_EXCO_SUCCESS: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        id: action.data.id,
        name: action.data.name,
        description: action.data.description,
        options: action.data.options,
        decision: action.data.decision
      }
    }
    case FETCHING_EXCO_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.data
      }
    }
    case SUBMITTING_EXCO_START: {
      return {
        ...state,
        isSubmitting: true,
        error: null
      }
    }
    case SUBMITTING_EXCO_SUCCESS: {
      return {
        ...state,
        isSubmitting: false,
        error: null,
        decision: action.data
      }
    }
    case SUBMITTING_EXCO_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: action.data
      }
    }
    case RESET: {
      return initialState
    }
    default: return state
  }
}

export default reducer

export function fetchingExcoStart () {
  return {
    type: FETCHING_EXCO_START
  }
}

export function fetchingExcoSuccess (data) {
  return {
    type: FETCHING_EXCO_SUCCESS,
    data
  }
}

export function fetchingExcoError (error) {
  return {
    type: FETCHING_EXCO_ERROR,
    data: error
  }
}

export function submittingExcoStart () {
  return {
    type: SUBMITTING_EXCO_START
  }
}

export function submittingExcoSuccess (decision) {
  return {
    type: SUBMITTING_EXCO_SUCCESS,
    data: decision
  }
}

export function submittingExcoError (error) {
  return {
    type: SUBMITTING_EXCO_ERROR,
    data: error
  }
}

// Action Creators
export function fetchDecision (team, round) {
  return async (dispatch) => {
    dispatch(fetchingExcoStart())

    try {
      const response = await api.getExcoDecision(team, round)
      dispatch(fetchingExcoSuccess(response))
    } catch (e) {
      dispatch(fetchingExcoError(e))
    }
  }
}

export function submitDecision (team, round, decision) {
  return async (dispatch) => {
    dispatch(submittingExcoStart())

    try {
      await api.submitExcoDecision(team, round, decision)
      dispatch(submittingExcoSuccess(decision))
    } catch (e) {
      dispatch(submittingExcoError(e))
    }
  }
}
